<template>
  <div class="auth-delimiter">
    <div class="auth-delimiter__content">
      <slot>
        или
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "AuthDelimiter"
};
</script>

<style lang="scss">
.auth-delimiter {
  display: flex;
  justify-content: center;
  color: colors(text-2);
  align-items: center;

  &__content {
    flex-shrink: 0;
    padding: 0 15px;
    font-size: 30px;
    text-transform: uppercase;
    font-weight: bold;
  }

  &::before,
  &::after {
    content: "";
    display: block;
    height: 3px;
    background-color: colors(palette-2);
    flex-grow: 1;
  }
}
</style>
